import { appLink } from '@experience/core-app-link-lib';
import { createI18n } from '@experience/i18n';
import { initWebComponent } from '@experience/vite-plugin-wc-extract-styles';
import { createHead } from '@unhead/vue/client';
import { createPinia } from 'pinia';
import { defineCustomElement } from 'vue';
import { createWebHistory, createRouter, createRouterMatcher } from 'vue-router';

import { defaultRoutes } from '@/router';

import { MF_NAME } from '@/shared/consts';
import { i18nPluralize as ruI18nPluralize } from '@/shared/utils/language/ru';
import { createLogger } from '@/shared/utils/logger';

import App from '@/app/App.ce.vue';

const matcher = createRouterMatcher(defaultRoutes, {});

export default initWebComponent({
  elementName: MF_NAME,
  stylesUrl: new URL(`${window.location.origin}/mfs/${MF_NAME}/extracted-styles.css`),
  dev: import.meta.env.DEV,
  defineElement: (styles) =>
    defineCustomElement(App, {
      styles,
      configureApp(app) {
        createLogger(import.meta.env.VITE_LOG_LEVEL ?? 'none');

        app.use(appLink({ matcher, hostAppRouterName: '__HOST_APP_ROUTER__' }));
        app.use(createPinia());
        app.use(createHead());
        app.use(
          createI18n({
            legacy: false,
            locale: 'ru',
            fallbackLocale: 'ru',
            pluralRules: {
              ru: ruI18nPluralize,
            },
          }),
        );
        app.use(createRouter({ history: createWebHistory('/'), routes: defaultRoutes }));
      },
    }),
});
